// 多个
export function toggleRowsStatus (selection, data, val) {
  const stack = [...data]
  const arr = [...selection]
  let selectionChanged = false
  while (stack.length) {
    const row = stack.shift()
    let changed = false
    const index = arr.indexOf(row)
    const included = index !== -1
    if (typeof val === 'boolean') {
      if (val && !included) {
        arr.push(row)
        changed = true
      } else if (!val && included) {
        arr.splice(index, 1)
        changed = true
      }
    } else {
      if (included) {
        arr.splice(index, 1)
        changed = true
      } else {
        arr.push(row)
        changed = true
      }
    }
    selectionChanged = changed
  }
  return {
    selectionChanged,
    arr
  }
}
// 单个
export function toggleRowStatus (statusArr, row, newVal) {
  let changed = false
  const index = statusArr.indexOf(row)
  const included = index !== -1

  const addRow = () => {
    statusArr.push(row)
    changed = true
  }
  const removeRow = () => {
    statusArr.splice(index, 1)
    changed = true
  }

  if (typeof newVal === 'boolean') {
    if (newVal && !included) {
      addRow()
    } else if (!newVal && included) {
      removeRow()
    }
  } else {
    if (included) {
      removeRow()
    } else {
      addRow()
    }
  }
  return changed
}

export const getRowIdentity = (row, rowKey) => {
  if (!row) throw new Error('row is required when get row identity')
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey]
    }
    let key = rowKey.split('.')
    let current = row
    for (let i = 0; i < key.length; i++) {
      current = current[key[i]]
    }
    return current
  } else if (typeof rowKey === 'function') {
    return rowKey(row)
  }
}

export const getKeysMap = function(array = [], rowKey) {
  const arrayMap = {}
  array.forEach((row, index) => {
    arrayMap[getRowIdentity(row, rowKey)] = { row, index }
  })
  return arrayMap
}


export function isTextSelected() {
  var selection = window.getSelection()
  return selection.toString().length > 0
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/selection.js